var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5503 16.101C33.5503 17.1677 32.7903 18.0358 31.8488 18.0358C31.8454 18.0358 31.8386 18.0358 31.8317 18.0358H28.5932V28.3286C28.5932 29.3952 27.8298 30.2634 26.8918 30.2634H21.3048C20.3668 30.2634 19.6034 29.3952 19.6034 28.3286V22.8708C19.6034 21.0917 18.3299 19.6474 16.7688 19.6474C15.2043 19.6474 13.9308 21.0956 13.9308 22.8708V28.3247C13.9308 29.3914 13.1674 30.2595 12.2294 30.2595H6.6424C5.70439 30.2595 4.94097 29.3914 4.94097 28.3247V18.0358H1.70244C0.983531 18.0358 0.343356 17.5258 0.100295 16.7589C-0.142765 15.9881 0.0660615 15.1278 0.617228 14.6061L15.6836 0.44379C16.3135 -0.14793 17.2241 -0.14793 17.8506 0.44379L32.7766 14.4738C33.2422 14.8241 33.5503 15.4198 33.5503 16.101Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeGray);
export default __webpack_public_path__ + "static/media/icon_home-gray.e7afbb44c72bc1d9800456fa7f4a850a.svg";
export { ForwardRef as ReactComponent };